import React from 'react';
import { Box, Grid, Text, Title } from '@mantine/core';
import { Package } from '../package/Package';
import { CartLine, Collection, Product } from '@common/merch';

interface CategoryContentProps {
  collection: Collection;
  onAddToCart?: (merchandiseId: string) => void;
  onViewDetails?: (productData: Product) => void;
  cartItems?: CartLine[];
  onUpdateQuantity?: (lineId: string, quantity: number) => void;
  onRemoveFromCart?: (lineId: string) => void;
  isLoading?: boolean;
  loadingLineId?: string;
  loadingOperation?: 'add' | 'remove' | 'update';
  productBanners?: Map<string, { text: string; color: string }>;
}

export const CategoryContent: React.FC<CategoryContentProps> = ({
  collection,
  onAddToCart,
  onViewDetails,
  cartItems = [],
  onUpdateQuantity,
  onRemoveFromCart,
  isLoading = false,
  loadingLineId,
  loadingOperation,
  productBanners
}) => {
  const getCartItem = (productId: string) => {
    return cartItems.find((item) => item.merchandise.product.id === productId);
  };
  
  return (
    <Box>
      <Title order={4} fw={700} c='white' mb={16}>
        {collection.title}
      </Title>

      {collection.description && (
        <Text size='md' c='white' mb={24} dangerouslySetInnerHTML={{ __html: collection.description || '' }} />
      )}

      {collection.products && collection.products.length > 0 ? (
        <Grid gutter={16}>
          {collection.products.map((product) => {
            const cartItem = getCartItem(product.id);
            const isInCart = !!cartItem;
            const isProductLoading = isLoading && loadingLineId === cartItem?.id;
            const showLoading = isProductLoading && (loadingOperation === 'add' || loadingOperation === 'remove');

            return (
              <Grid.Col key={product.id} span={{ base: 12, sm: 6, md: 4 }}>
                <Package
                  product={product}
                  onAddToCart={onAddToCart}
                  onViewDetails={onViewDetails}
                  isInCart={isInCart}
                  quantity={cartItem?.quantity}
                  lineId={cartItem?.id}
                  onUpdateQuantity={onUpdateQuantity}
                  onRemove={onRemoveFromCart}
                  isLoading={showLoading}
                  disabled={isLoading}
                  banner={productBanners?.get(product.id)}
                />
              </Grid.Col>
            );
          })}
        </Grid>
      ) : (
        <Text size='sm' c='dimmed' ta='center'>
          No products available in this collection.
        </Text>
      )}
    </Box>
  );
};
